import * as React from 'react';
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import Skeleton from '@material-ui/lab/Skeleton';
import { Wrapper, StyH5 } from '../GroupsWidget';

const SkeletonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacings.SPACING_6};
  justify-content: space-between;
`;

const StyWrapper = styled(Wrapper)`
  min-height: 320px;
`;

const GroupsSkeletonLoader = () => {
  return (
    <StyWrapper>
      <StyH5>Group</StyH5>
      <SkeletonWrapper>
        {[...Array(6).keys()].map((key) => (
          <Skeleton
            key={key}
            variant="circle"
            width={Spacings.SPACING_10B}
            height={Spacings.SPACING_10B}
          />
        ))}
      </SkeletonWrapper>
    </StyWrapper>
  );
};

export default GroupsSkeletonLoader;
